import Client from './client';

export class AuthApi {
    static async loginOidc(code, redirectUri) {
        return Client.post('/auth/oidc', { code, redirectUri });
    }
}
